import { ContextMenuBar } from "lib/@components/context-menu-bar"
import "routes/asset-register/plugins/rename-register/rename-register-menu-item"
import "routes/asset-register/plugins/edit-register-description/edit-register-description-menu-item"
import "routes/asset-register/plugins/export-register/export-register-menu-item"
import "routes/asset-register/plugins/remove-register/remove-register-menu-item"
import { BlockClicks } from "lib/@components/block-clicks"
import { Secure } from "lib/authorization/secure"

export function RegisterRowActionsMenu({ item }) {
    return (
        <Secure hide demand="manageAssetRegister">
            <BlockClicks>
                <ContextMenuBar type="assetRegisters" register={item} />
            </BlockClicks>
        </Secure>
    )
}
